import { ICourse2 } from '@et/types/Courses'
import { colors } from '@styles/global/colors'
import { PAYMENT_TYPES_THEME } from '@et/types/Enums'

const slug = '3d-lettering-in-procreate'
const title = '3D Lettering in Procreate'
const course: ICourse2 = {
  theme: PAYMENT_TYPES_THEME.DARK,
  title,
  slug,
  videoId: `b0zendz71k`,
  keywords: [
    '3D', 'procreate', 'lettering', 'hand lettering', 'design', 'digital art', 'digital', 'ipad', 'ipad lettering', 'typography', 'tutorial', 'tutorials', 'how to', 'diy', 'beginners', 'introduction', 'dimension', 'dimensional', 'artwork', 'hand drawn', 'brushes', '3D lettering', 'project', 'project based learning', 'learn', 'learning', 'course', 'online course', 'guide', 'class',
  ],
  price: '67',
  salePrice: '67',
  paymentPlan:{
      perMonth: '0',
      price: '0',
      savings: '0',
  },
  motionMail: '',
  onSale: false,
  tagline: 'Create stunning, pop-off-the-screen dimensional iPad lettering.',
  classDescriptor: 'Create eye catching iPad lettering that simulates real depth',
  intro: {
    imgName: 'procreate201/tablet-side.png',
    imgAlt: 'Welcome to 3d Lettering in Procreate',
    bullets: [
      {
        title: 'Beginner Basics',
        desc:
          'New to iPad lettering? The course includes a basics section to get you started, so you feel confident and prepared heading into the more advanced projects.',
      },
      {
        title: 'Long Shadow + Extrusion Methods',
        desc:
          'We cover two different methods for creating your 3D extrusions and shadows that allow your lettering to ‘pop’ off the screen.',
      },
      {
        title: 'Inner shadows, outer highlights, masking, strokes and fills',
        desc:
          'Learn all the tools you’ll need to create your own projects from the methods and tricks covered throughout the class via step-by-step tutorials and projects.',
      },
      {
        title: 'Original Procreate files and color palettes provided',
        desc:
          'Every project includes the exact colors used so you can follow along exactly. Want to take a look under the hood to understand the files better? Every project file is included for your convenience.',
      },
    ],
  },
  projects: {
    beginner: [
      {
        title: 'Project 1',
        backgroundColor: `#6482b3`,
        textColor: `#313A54`,
        subheadColor: `#fdfdfb`,
        projectImg: `procreate201/project-1.jpg`,
        projectImgMobile: `procreate201/project-1-mobile.jpg`,
        type: 'Beginner',
        desc:
          'In the first Beginner Basics projects of the course, you’ll learn how to manually implement a 3D extrusion and shadow. We’ll go over choosing colors to enhance believability and discuss proper layer order in Procreate.',
      },
      {
        title: 'Project 2',
        backgroundColor: `#fdcaa6`,
        textColor: `#313A54`,
        subheadColor: `#d3684c`,
        projectImg: `procreate201/project-2.jpg`,
        projectImgMobile: `procreate201/project-2-mobile.jpg`,
        type: 'Beginner',
        desc:
          'In the second Beginner Basics project, you’ll learn a quick trick for implementing a 3D extrusion and shadow with softer edges. We’ll also take things a step further with extrusion shading and discuss where to put that shading in future projects/lettering styles.',
      },
      {
        title: 'Project 3',
        backgroundColor: `#393434`,
        textColor: `#f0f0f0`,
        subheadColor: `#5eb299`,
        projectImg: `procreate201/project-3.jpg`,
        projectImgMobile: `procreate201/project-3-mobile.jpg`,
        type: 'Beginner',
        desc:
          'Beginner Basics project #3 will take you into creative shadows. First, I’ll share my trick for using existing typefaces for 3D methods if that’s something you’d like to use. Next, we’ll create a standard floating shadow, understanding how to create the negative space distance between where your lettering ends and a floating shadow begins. Finally, we’ll use our standard floating shadow as a base for a hatched style floating shadow to add extra visual interest.',
      },
      {
        title: 'Project 4',
        type: 'Beginner',
        projectImg: `procreate201/project-4.jpg`,
        projectImgMobile: `procreate201/project-4-mobile.jpg`,
        backgroundColor: `#c0243c`,
        textColor: `#f0f0f0`,
        subheadColor: `#f0f0f0`,
        desc:
          'Now that we have an understanding of outer shadows, it’s time to take things inside with Beginner Basics project #4. In this project, we’ll simulate a debossed lettering effect by applying a hard, fine line highlight to our lettering and longer, perfectly masked soft inner shadows to create the effect of being ‘pushed’ in.',
      },
      {
        title: 'Project 5',
        type: 'Beginner',
        projectImg: `procreate201/project-5.jpg`,
        projectImgMobile: `procreate201/project-5-mobile.jpg`,
        backgroundColor: `#283d43`,
        textColor: `#f0f0f0`,
        subheadColor: `#5eb299`,
        desc:
          'Now that we have an understanding of outer shadows, it’s time to take things inside with Beginner Basics project #4. In this project, we’ll simulate a debossed lettering effect by applying a hard, fine line highlight to our lettering and longer, perfectly masked soft inner shadows to create the effect of being ‘pushed’ in.',
      },
    ],
    advanced: [
      {
        title: 'Project 6',
        backgroundColor: `#015d4e`,
        textColor: `#f0f0f0`,
        subheadColor: `#5eb299`,
        projectImg: `procreate201/project-6.jpg`,
        projectImgMobile: `procreate201/project-6-mobile.jpg`,
        type: 'Advanced',
        desc:
          'In the first advanced project of the course, we’ll take tips from our beginner basics projects, combine them and introduce new ones, all to one set of lettering. In this project, you’ll learn how to apply hard highlights and shadows to subtle gradient base lettering, apply a gradient extrusion, hard line shading on that extrusion and finalize the piece with long soft shadows.',
      },
      {
        title: 'Project 7',
        backgroundColor: `#fde2e1`,
        textColor: `#313A54`,
        subheadColor: `#f9b2ae`,
        projectImg: `procreate201/project-7.jpg`,
        projectImgMobile: `procreate201/project-7-mobile.jpg`,
        type: 'Advanced',
        desc:
          'In advanced project #2, you’ll learn how to apply a multi-colored extrusion to script lettering. We’ll introduce a gold texture to our original base lettering, apply highlights to it and implement halftone shading to our extrusion. A long soft shadow set in the multiply blend mode will lift the lettering slightly from the background for the finished piece.',
      },
      {
        title: 'Project 8',
        backgroundColor: `#6eb6ad`,
        textColor: `#f0f0f0`,
        subheadColor: `#e2e9b1`,
        projectImg: `procreate201/project-8.jpg`,
        projectImgMobile: `procreate201/project-8-mobile.jpg`,
        type: 'Advanced',
        desc:
          'We’ll use what we learned in the Beginner Basics floating shadows project and take things even further. In this third advanced project, we’ll use stroked text without a fill, apply a hatched floating shadow to it, an inline with a texture and a hard inner shadow to simulate a ‘push’ in the same direction as our floating shadows. We’ll liven up the background with some additional texture and hand drawn confetti to finish the project up.',
      },
      {
        title: 'Project 9',
        backgroundColor: `#fc7f7f`,
        textColor: `#f0f0f0`,
        subheadColor: `#f73d3d`,
        projectImg: `procreate201/project-9.jpg`,
        projectImgMobile: `procreate201/project-9-mobile.jpg`,
        type: 'Advanced',
        desc:
          'In this soft and subtle, but eye catching advanced project, we’ll take our shading game up another notch.We’ll apply fine, soft highlights to our lettering, juxtaposed next to soft inner shadows. We’ll apply outer fine, soft shadows to the other sides of our lettering and extend our longest shadows yet in the same direction, then soften them for consistency.',
      },
      {
        title: 'Project 10',
        backgroundColor: `#e0e7ab`,
        textColor: `#313A54`,
        subheadColor: `#8b9543`,
        projectImg: `procreate201/project-10.jpg`,
        projectImgMobile: `procreate201/project-10-mobile.jpg`,
        type: 'Advanced',
        desc:
          'As you go through the course, you’ll notice the advanced projects becoming more advanced and this project is no different! In ‘Citrus,’ you’ll apply a pattern to your base lettering, utilize an outer stroke with a soft inner shadow, a double color and layer 3D extrusion and a same direction, long soft shadow. The entire piece is finished with halftone shading for extra depth and pop-off-the-page goodness.',
      },
      {
        title: 'Bonus! Project 11',
        backgroundColor: `#48b8a8`,
        textColor: `#313A54`,
        subheadColor: `#cbea9e`,
        projectImg: `procreate201/project-11.jpg`,
        projectImgMobile: `procreate201/project-11-mobile.jpg`,
        type: 'Advanced',
        desc: 'For the final advanced 3D project and those looking for a challenge, we’ll integrate an ‘open box’ lettering feel paired with a neon lettering effect. We’ll create our base lettering, extrude our lettering forward so our base lettering looks like it’s ‘sinking down’ and we’ll apply double colored highlights inside and double colored shadows outside to make things more realistic. We’ll apply a hard long shadow to make our lettering appear fixed to a wall, then add in our neon lettering effect, complete with brackets.',
      },
    ],
  },
  curriculum: [
    {
      title: 'Welcome',
      videos: [
        {
          title: 'Course Overview + Bonuses',
          duration: '6:14',
        },
      ],
    },
    {
      title: '[Beginner Basics] Project: Hello',
      videos: [
        {
          title: 'File setup',
          duration: '3:12',
        },
        {
          title: 'Implementing manual shadows',
          duration: '9:50',
        },
        {
          title: 'Implementing manual extrusions',
          duration: '3:19',
        },
      ],
    },
    {
      title: '[Beginner Basics] Project: Basic',
      videos: [
        {
          title: 'File setup',
          duration: '3:14',
        },
        {
          title: 'Automated extrusion + long shadow',
          duration: '6:32',
        },
        {
          title: 'Extrusion shading + background glow',
          duration: '7:35',
        },
      ],
    },
    {
      title: '[Beginner Basics] Project: Float',
      videos: [
        {
          title: 'Using existing typefaces + apply a simple floating shadow',
          duration: '8:24',
        },
        {
          title: 'floating hatch shadows + inline',
          duration: '3:03',
        },
        {
          title: 'Finalizing the layout',
          duration: '2:48',
        },
      ],
    },
    {
      title: '[Beginner Basics] Project: Push',
      videos: [
        {
          title: 'File setup',
          duration: '4:05',
        },
        {
          title: 'Adding subtle highlights + soft inner shadows',
          duration: '7:54',
        },
        {
          title: 'Finalizing the layout',
          duration: '3:12',
        },
      ],
    },
    {
      title: '[Beginner Basics] Project: Stuck',
      videos: [
        {
          title: 'File setup',
          duration: '4:00',
        },
        {
          title: 'Applying warped shadows',
          duration: '3:39',
        },
        {
          title: 'Shadow masking',
          duration: '6:40',
        },
      ],
    },
    {
      title: '[Advanced] Project: Light',
      videos: [
        {
          title: 'File setup',
          duration: '5:30',
        },
        {
          title: 'Extrusion + long shadow',
          duration: '4:27',
        },
        {
          title: 'Extrusion gradient + shading',
          duration: '6:18',
        },
        {
          title: 'Subtle fine line highlights + shadows',
          duration: '5:36',
        },
      ],
    },
    {
      title: '[Advanced] Project: Rainbow',
      videos: [
        {
          title: 'File setup',
          duration: '2:40',
        },
        {
          title: 'Rainbow extrusion',
          duration: '3:46',
        },
        {
          title: 'Long shadow fade',
          duration: '4:15',
        },
        {
          title: 'Halftone extrusion shading',
          duration: '3:21',
        },
        {
          title: 'Adding gold texture + texture highlights',
          duration: '4:01',
        },
        {
          title: 'Finalizing + background details',
          duration: '1:55',
        },
      ],
    },
    {
      title: '[Advanced] Project: Party!',
      videos: [
        {
          title: 'File setup',
          duration: '5:01',
        },
        {
          title: 'Subtle inner shadow',
          duration: '3:12',
        },
        {
          title: 'Floating hatch shadow',
          duration: '3:29',
        },
        {
          title: 'Glitter inline',
          duration: '2:08',
        },
        {
          title: 'Finalizing + background details',
          duration: '4:42',
        },
      ],
    },
    {
      title: '[Advanced] Project: Hey, Beautiful',
      videos: [
        {
          title: 'File setup',
          duration: '2:24',
        },
        {
          title: 'Subtle outer shadow',
          duration: '2:12',
        },
        {
          title: 'Soft outer highlight',
          duration: '2:09',
        },
        {
          title: 'Subtle inner shadow',
          duration: '2:57',
        },
        {
          title: 'Long soft shadow',
          duration: '3:09',
        },
        {
          title: 'Finalizing + background details',
          duration: '1:44',
        },
      ],
    },
    {
      title: '[Advanced] Project: Citrus',
      videos: [
        {
          title: 'File setup',
          duration: '4:42',
        },
        {
          title: 'Soft inner shadow',
          duration: '2:52',
        },
        {
          title: 'Adding pattern to lettering',
          duration: '1:35',
        },
        {
          title: 'Double color 3D extrusion',
          duration: '3:14',
        },
        {
          title: 'Soft long shadow',
          duration: '2:50',
        },
        {
          title: 'Halftone extrusion shading + background texture',
          duration: '4:52',
        },
      ],
    },
    {
      title: '[Advanced] Project: Neon',
      videos: [
        {
          title: 'File setup',
          duration: '4:55',
        },
        {
          title: 'Open letter extrusion',
          duration: '2:01',
        },
        {
          title: 'Open letter shading',
          duration: '5:18',
        },
        {
          title: 'Long shadow + neon letters with brackets',
          duration: '5:56',
        },
        {
          title: 'Script neon lettering + background glow',
          duration: '5:20',
        },
      ],
    },
    {
      title: 'Next Steps',
      videos: [
        {
          title: 'Thank You + Next Steps',
          duration: '0:54',
        },
      ],
    },
  ],
  bonuses: {
    headerImgName: `procreate201/bonuses-title.png`,
    imgAlt: '3d Lettering for Procreate Bonuses',
    gridType: 3,
    items: [
      {
        title: 'Custom Procreate Monoweight Brush',
        desc: 'The brush used in all class projects is the Every-Tuesday monoweight brush to keep the focus on 3D techniques. Download the brush and follow along exactly.',
        imgName: 'procreate201/bonuses-1.jpg',
        imgAlt: 'Custom Procreate Monoweight Brush',
      },
      {
        title: 'Gold Foil Texture',
        desc: 'If you’d like to add extra texture to your lettering, experiment by using this free designed-for-Procreate high resolution gold foil texture.',
        imgName: 'procreate201/bonuses-2.jpg',
        imgAlt: 'Gold Foil Texture',
      },
      {
        title: '11 Procreate Project Files',
        desc: 'Access to every Procreate project file in the class (the exact files made in the videos) to help if you get stuck along the way.',
        imgName: 'procreate201/bonuses-3.jpg',
        imgAlt: '11 Procreate Project Files',
      },
    ],
  },
  courseCard: {
    title: 'Lettering in Procreate',
    backgroundImgName: `procreate201/sell-card-bg.jpg`,
    backgroundColor: '#73b8ad',
    cardImgName: `procreate201/3d-title.png`,
    desc: 'Create stunning, jump-off-the-screen dimensional iPad lettering in Procreate! Take your instagram game to the next level, or create digital and print designs for your etsy shop or other social media platforms. Made with beginners in mind, we start with simple projects covering all the 3D building blocks you’ll need no matter your Procreate or lettering experience level. From there, move into the course’s more advanced projects with confidence to create the 3D iPad artwork you’ve always wanted.',
    bullets: [
      'Access to 48 HD step-by-step videos',
      'Gold Foil Procreate texture',
      'Every project’s color palette',
      'Unlimited updates',
      'Every-Tuesday Monoweight Procreate Brush',
      'Beginner 3D lettering basics projects',
      'Every project’s fully layered original Procreate file',
      'Lifetime access to the class\n',
    ],
    brush: {
      enabled: true,
      image: {
        pencil: `apple2-pencil.png`,
        shadow: `procreate201/sell-card-pencil-reflection.png`,
      },
    },
    priceColor: '#00d47f',
    saleColor: '#00d47f',
    stats:{
      modules: '#ef6981',
      videos: '#f3c100',
      hours: '#01b7b8'
    }
  },
  faqs: [
    {
      question: 'Do you offer any refunds or guarantees?',
      answer: 'Sure do! If you finish the course, implement the techniques and feel you haven’t learned anything new, you can email me within 14 days of purchase for a full refund.',
    },
    {
      question: 'How long can I access the course for?',
      answer: 'Forever! As long as Every-Tuesday exists, this course will be available to watch. Take it at whatever pace you’d like, watch whenever, wherever and as many times as you’d like.',
    },
    {
      question: 'Is this a live or pre-recorded course?',
      answer: 'This course is entirely pre-recorded, so you can take it whenever it works best with your schedule.',
    },
    {
      question: 'Will I be able to access all the videos and bonuses at once?',
      answer: 'Yup!',
    },
    {
      question: 'What will I need to take this class?',
      answer: 'You’ll need an Apple Pencil and an iPad that is compatible with the Apple Pencil (in the videos, I’m using a second generation Apple Pencil and a third generation iPad Pro, 12.9”, 256GB). You will also need the Procreate App (version 4.2 or newer) installed on your iPad to follow along and complete the course.',
    },
    {
      question: 'Do I need any special Procreate brushes to create these projects?',
      answer: 'I recommend using my custom monoweight Procreate brush (included for free with your enrollment) for all of the projects, which is exactly what you’ll see me using. All other brushes used within the course are default brushes you’ll already have access to in Procreate to keep the focus on our effects.',
    },
    {
      question: 'I noticed there’s a similar course offered on Skillshare. What’s the difference?',
      answer: 'The course offered on Skillshare is a very limited/lite version of this course and only includes the 5 beginner basics projects and the free Procreate monoweight brush. This course includes the 5 beginner basics projects, the 6 advanced projects, all of the original 11 Procreate project files as well as the free Procreate gold foil texture. You also receive lifetime access to all of the content within this version of the course (no monthly subscription - yay!) and this course will qualify for free future updates unlike the Skillshare version. For a chart of similarities and differences, please visit: every-tuesday.com/3D-comparison-chart',
    },
    {
      question: 'I’m still learning hand lettering. Is this for me?',
      answer: 'Yes! This course focuses on Procreate tools, workflow and effects, so you’ll be able to follow along and complete the projects no matter your lettering background. You’ll also see my trick for using existing typefaces if you’re not ready to use your own lettering yet ;)',
    },
  ],
  testimonials: [
    {
      author: 'James S.',
      quote: '"These interesting and engaging sample projects build nicely to increase in complexity as you get familiar with the way the layers, selection tools, and workflow of procreate are laid out. Really good class!"',
    },
    {
      author: 'Julie C.',
      quote: '"Teela made an absolutely awesome tutorial for teaching you many different ways to apply 3d effects to your procreate lettering! So many applications, thanks Teela!"',
    },
    {
      author: 'Tiffany G.',
      quote: '"I have taken several courses on 3D lettering and this class presented a number of techniques I have not come across. I was able to use the techniques in my own lettering right away. I also liked that Teela provided a detailed explanation of each technique without overwhelming me with information. It was a very nice balance. The projects were really fun to do!"',
    },
    {
      author: 'Oksana P.',
      quote: '"Loved this class! Amazing, clear lessons and beautiful examples! I love how a beginner can build their skills with every project to include more and more helpful tools and techniques. Thank you so much, Teela, for this great class!"',
    },
    {
      author: 'Juliet C.',
      quote: '"This class was sooooo amazing! I loved and frankly, I\'m amazed at what I was able to create while listening along. Great class!"',
    },
  ],
  letsDoThis: {
    imgName: 'procreate201/lets-do-this.png',
    altTag: 'Enroll in 3d Lettering for Procreate Today!',
    text: 'Welcome to 3D Lettering in Procreate, your one stop for creating stunning, pop-off-the-screen, dimensional iPad lettering.',
  },
  sellCard: {
    priceColor: '#fff',
    cardImg: 'procreate201/sell-card.jpg',
    saleLink: 'https://courses.every-tuesday.com/purchase?product_id=3334973',
    paymentPlanLink: 'https://courses.every-tuesday.com/purchase?product_id=3334973',
    link: 'https://courses.every-tuesday.com/purchase?product_id=3334973',
    customBtnBackgroundColor: colors.primary.pink,
    h2Color: `#fff`,
    hoverColor: {
      h2: `#fff`,
      text: '#147590',
      overlay: '#01ADB3',
    },
    bullets: [
      'Instant access to all videos and bonuses',
      'Every-Tuesday Monoweight Procreate Brush',
      'All original Procreate project files',
      'Color swatches for each project',
      'Gold foil Procreate texture',
      '14 day money back guarantee',
    ],
  },
}
export default course
